export default "__VITE_ASSET__BL6sOtsB__"